import { compareStory } from './storyTime'
import type { WindKeyframe } from './types'

export function sortWindFrames(frames: WindKeyframe[]): WindKeyframe[] {
  return [...frames].sort((a, b) => compareStory(a.at, b.at))
}
